import { Thead, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'

import type { IEntry } from '@app/domain/instrument/instrument.interface'
import type { IDataInstrument } from '@app/domain/visit/visit.interface'

import { ResponseHistoryHeaderColumn } from './response-history-header-column'

interface Props {
  editResponses?: boolean
  entries: IEntry[]
  instrument: IDataInstrument
  openEditInstrumentModal?: (entry: IEntry) => void
}

export const ResponseHistoryHeader = ({
  editResponses,
  entries,
  instrument,
  openEditInstrumentModal,
}: Props) => {
  return (
    <Thead>
      <Tr>
        <Th isStickyColumn width={10} />
        {entries.map((entry) => (
          <ResponseHistoryHeaderColumn
            entry={entry}
            editResponses={editResponses}
            instrument={instrument}
            key={entry.id}
            openEditInstrumentModal={() => openEditInstrumentModal(entry)}
          />
        ))}
      </Tr>
    </Thead>
  )
}
